<app-header [label]="page_name | plural"></app-header>
<app-ag-grid-list #list [list]="items" [colDefs]="columns" [bulk_delete]="false" [disable_permission]="false" [show_checkboxes]="true" [hide_bulk_toolbar]="true" [itemName]="page_name" (fetch_new_list)="get_list($event)">
  <div toolbar class="flex flex-wrap bg-white gap-4 items-center justify-between p-4">
    <div class="flex gap-4 flex-1">
        <app-select-input label="University" [is_disabled]="gs.access_scope.locked.university" [depended]="1" class="flex-1" [options]="dds.dropdown_list?.university_list" (valueChange)="onDropdownChange($event)" (registerSelf)="registerDropdown($event)" [(ngModel)]="params.university_id"></app-select-input>
        <app-select-input label="Subject Name" [is_disabled]="gs.access_scope.locked.subject" [depended]="2" class="flex-1" [options]="params.university_id ? (dds.dropdown_list?.subject_list | filterByKeyAndValue : 'university_id' : params.university_id) : []" (valueChange)="onDropdownChange($event)" (registerSelf)="registerDropdown($event)" [(ngModel)]="params.subject_id"></app-select-input>
    </div>
    <div class="flex gap-2 items-center">
        <app-search-input *ngIf="!list || list.selected_ids_count <= 0" #searchbar></app-search-input>
        <app-button color="bg-white border-primary text-primary" icon="bx bx-download" (click)="download()"></app-button>
        <app-button *ngIf="gs.user_role_data?.assignments_assign_evaluation_assign && list.selected_ids_count > 0" color="bg-secondary text-[#310000]" [label]="page_name" (click)="open_form_modal()"></app-button>
    </div>
  </div>
</app-ag-grid-list>
<app-modal #form_modal [label]="page_name">
    <form [formGroup]="form">
        <div class="py-2 grid grid-cols-1 gap-4">
            <app-detailed-select-input
              class="w-full"
              placeholder="Select Head Evaluator"
              displayKey="title"
              subDisplayKey="email"
              valueKey="value"
              formControlName="head_evaluator_id"
              [options]="filtered_head_evaluator_list"
            ></app-detailed-select-input>
        </div>
        <div class="flex justify-end items-center gap-2 mt-2">
            <app-button color="border-primary text-primary" label="Cancel" type="button" (click)="close_form_modal()"></app-button>
            <app-button color="bg-secondary text-black" [label]="'Assign'" type="button" [submit]="submit.bind(this)"></app-button>
        </div>
    </form>
</app-modal>